import React from "react";
import { getRecaptchaSiteKey } from "../utils/config";
import "../styles/recaptcha-disclosure.css";

type Props = {
    className?: string;
};

/**
 * Required when the reCAPTCHA v3 badge is hidden (see global CSS).
 * @see https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge.-what-is-allowed
 */
export function RecaptchaDisclosure({ className = "" }: Props) {
    if (!getRecaptchaSiteKey()) {
        return null;
    }
    const combined = ["recaptcha-disclosure", className].filter(Boolean).join(" ");
    return (
        <p className={combined} role="note">
            This site is protected by reCAPTCHA and the Google{" "}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
            </a>{" "}
            and{" "}
            <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
                Terms of Service
            </a>{" "}
            apply.
        </p>
    );
}
